import { render, staticRenderFns } from "./ufis.vue?vue&type=template&id=766f6054&scoped=true"
import script from "./ufis.vue?vue&type=script&lang=js"
export * from "./ufis.vue?vue&type=script&lang=js"
import style0 from "./ufis.vue?vue&type=style&index=0&id=766f6054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f6054",
  null
  
)

export default component.exports